import React from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Header from './components/header/Header';
import Home from './pages/Home';
import Services from './pages/Services'
import Projects from './pages/Projects';
import Reviews from './pages/Reviews';
import SendMessage from './pages/SendMessage';
import Contact from './pages/Contact';
// SafetyPolicy route removed per request
import ScrollToTop from './components/scroll-to-top/ScrollToTop';
import NotFound from './components/not-found/NotFound';
import Footer from './components/footer/Footer';

function App() {
  return (
    <div className="gradient-frame">
      <div className="app-inner">
        <Router>
          <ScrollToTop />
          <Header />
          <main>
            <Switch>
              <Route exact path='/' component={Home} />
              <Route path='/services' component={Services} />
              <Route path='/projects' component={Projects} />
              <Route path='/reviews' component={Reviews} />
              <Route path='/send-message' component={SendMessage} />
              <Route path='/contact' component={Contact} />
              <Route component={NotFound} />
            </Switch>
          </main>
          {/* <Contact/> */}
          <Footer />
        </Router>
      </div>
    </div>
  );
}

export default App;
